import React, { useRef, useLayoutEffect } from 'react'
import { Card, CardBody, CardHeader, CardImg, CardText, CardTitle } from 'reactstrap'

function ServiceCardBase(props){
    const ref = useRef(null);

    useLayoutEffect(() => {
        ref.current.style.setProperty("border-radius", "150px", "important");
    }, []);    

    const { title, header, image, description } = props
    return <Card
        className="my-2"
        style={{
            maxWidth: "50em",
            border: "1px solid #ccc"
        }}>
        <CardHeader>
            <img src={image} style={{width:"15px"}} /> {header}
        </CardHeader>
        <CardBody>
            <img ref={ref} src={image} class="rounded mx-auto d-block img-thumbnail" style={{width:"75px"}} /><br />
            <h2 className="text-center">
                {title}
            </h2>
            <CardText tag="h4">
                {description}
            </CardText>
            {/* <button className="btn btn-lg btn-success btn-block mb-2 mt-2">Add LinkedIn Organization!</button> */}
            {props.children}
        </CardBody>
    </Card>
}

export default ServiceCardBase